import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { setToken, api } from '../api/client';
import posthog from '../lib/posthog';

export default function AuthCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = params.get('token');
    const redirect = params.get('redirect');
    if (token) {
      setToken(token);
      api.getMe().then(({ user }) => {
        posthog.identify(user.id, { name: user.name, email: user.email });
        posthog.capture('login_completed', { login_provider: 'google' });
      }).catch(() => {
        posthog.capture('login_completed', { login_provider: 'google' });
      });
      if (redirect) {
        try {
          const url = new URL(redirect);
          if (url.origin === window.location.origin) {
            navigate(`${url.pathname}${url.search}${url.hash}`, { replace: true });
            return;
          }
        } catch {
          navigate(redirect, { replace: true });
          return;
        }
      }
      navigate('/', { replace: true });
    } else {
      navigate('/login', { replace: true });
    }
  }, [params, navigate]);

  return <div>Signing in...</div>;
}
